import { createFileRoute } from "@tanstack/react-router";
import { CountryPage, ratesQueryOptions, historyQueryOptions } from "@/components/CountryPage";
import { GOLD_COUNTRY_ALIASES, goldCountryAliasMeta, buildAliasHead } from "@/lib/alias-routes";

const A = GOLD_COUNTRY_ALIASES.find((x) => x.slug === "gold-rate-pakistan")!;
const M = goldCountryAliasMeta(A);

export const Route = createFileRoute("/gold-rate-pakistan")({
  head: () => buildAliasHead({ title: M.title, description: M.description, path: M.path }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(ratesQueryOptions);
    void context.queryClient.prefetchQuery(historyQueryOptions("pakistan"));
  },
  component: () => (
    <CountryPage country="pakistan" title={M.h1} intro="Live 24K, 22K and 21K gold rates across every major Pakistani city — recalculated every 10 minutes from international spot price + today's USD/PKR rate." />
  ),
});